import { useEffect, useState, useCallback, useRef, useImperativeHandle } from 'react';
import { dashboard, person, backoffice } from 'apis';
import { useNavigate } from 'react-router';
import { format } from 'date-fns';
import { useQuery } from 'react-query';
import { isnil } from 'lodash/isNil';
import { useMe } from './useMe';

const useCard = () => {
    const navigate = useNavigate();
    const [avatar, setAvatar] = useState('');
    const [statuses, setStatuses] = useState(null);
    const palette = ['#1e88e5', '#1e88e5', '#e7bf0d', '#e7bf0d', '#0ce22f', '#e7bf0d', '#f0170f'];
    const paletteForPie = ['#1e88e5', '#f0170f', '#f88705', '#e7bf0d'];
    const whoami = useMe();

    const log = (key, data) => {
        localStorage.setItem(key, JSON.stringify({ ...data }));
    };

    const dashboardQuery = useQuery('dashboard', async () => {
        let statistics;
        let avatar;
        let status;
        try {
            statistics = await dashboard.statistics();
        } catch (error) {
            console.log('statistics error');
        }

        try {
            avatar = await person.getAvatar({ projectTableId: 2, recordId: statistics[2]?.Data?.[0]?.recordId });
        } catch {
            console.log('avatar error');
        }

        try {
            status = await backoffice.getLookups({ dataKey: 'Statuses' });
        } catch {
            console.log('statuses error');
        }
        return {
            statistics,
            status,
            avatar
        };
    });

    useEffect(() => {
        /* const fetchAvatar = async () => {
            try {
                const res = await person.getAvatar({
                    projectTableId: 2,
                    recordId: dashboardQuery.data.statistics[2].Data[0].recordId
                });
                if (res !== '') {
                    setAvatar(res);
                }
            } catch (error) {
                console.error(error);
            }
        }; */
        if (dashboardQuery.status === 'success') setAvatar(dashboardQuery?.data?.avatar);
        // fetchAvatar();
    }, [dashboardQuery.status]);

    const chartInitialized = (flex) => {
        flex?.hostElement?.addEventListener('mousedown', (e) => {
            const ht = flex.hitTest(e.pageX, e.pageY);

            if (ht?.item && dashboardQuery.status === 'success') {
                const filterStatus = dashboardQuery.data.status.filter((status) => status.label === ht.series.binding);
                const key = `explorer-${ht?.item.LoggingDatakey}-filters`;
                const data = { StatusId: filterStatus?.[0]?.value, DateFrom: '', DateTo: '' };

                log(key, data);
                if (ht?.item.nav) navigate(ht?.item.nav);
            }
        });
    };

    // // Function for assign color per column
    // const chartItemFormatter = (engine, ht, defRender) => {
    //     const pal = ht.chart.palette && !(ht.chart.palette.length === 0) ? ht.chart.palette : Palettes.standard;
    //     engine.fill = pal[ht.pointIndex]; // each bar has own color
    //     engine.stroke = null;
    //     defRender();
    // };

    const handleViewProfile = (userId) => {
        navigate(`/users-and-access/users/manage/${userId}/details`);
    };

    const handleClick = (value) => {
        navigate(`/${value.Datakey.toLowerCase()}`);
    };

    console.log('dashboardQuery statistics', dashboardQuery);

    return {
        status: dashboardQuery.status,
        statistics: dashboardQuery?.data?.statistics,
        dashboardQuery,
        log,
        handleClick,
        avatar,
        handleViewProfile,
        palette,
        paletteForPie,
        chartInitialized
    };
};

export default useCard;
